import { DataSource, Layout, Panel, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutIntellirouteCityList extends Layout {
    panelSpacer: Panel;
    searchpanelCity: SearchPanel;
    sourceIntellirouteCity: DataSource;
    tableCity: Table;
    textbox3DigitZip: Textbox;
    textboxAirportCode: Textbox;
    textboxCityName: Textbox;
    textboxCounty: Textbox;
    textboxId: Textbox;
    textboxLatitude: Textbox;
    textboxLongitude: Textbox;
    textboxOverrideZone: Textbox;
    textboxStateId: Textbox;
    textboxTimezone: Textbox;
    textboxZipCode: Textbox;
}
